
class ReviewSlider extends HTMLElement {
  constructor() {
    super();

    const slideEle = this.querySelector('.review-slider');
    const paginationEl = this.querySelector('.swiper-pagination');
    const nextBtn = this.querySelector('.swiper-button-next');
    const prevBtn = this.querySelector('.swiper-button-prev');

    new Swiper(slideEle, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }

  connectedCallback() {}
}

customElements.define('review-slider', ReviewSlider);

function showBadge() {
  document.querySelectorAll('.meta_connected_prd').forEach(elt => {
    let prod_badge = elt.querySelector('.prod_badge'),
        prod_var_wt = elt.querySelector('.prod_var_price').textContent.trim();

    if (prod_badge && prod_var_wt === '100g') {
      prod_badge.style.display = 'flex';
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // Initialize price per gram calculation using global function if available
  function initializePricePerGram() {
    if (window.updatePricePerGram) {
      window.updatePricePerGram();
    } else {
      // Fallback to original logic if global function is not available
      document.querySelectorAll(".meta_connected_prd").forEach(v => {
        let vp = parseInt(v.querySelector(".prod_var_price").textContent.trim()),
            gp = v.querySelector(".prod_price_gram"),
            ap = parseInt(v.querySelector(".prod_ac_price").textContent.trim()) / 100;
        
        if (gp) {
          // Check if subscribe is selected by default
          const isSubscribeSelected = document.querySelector('.subify-choice-box-wrapper.active .subify-choice-wrapper span')?.textContent.trim() === 'Subscribe & Save 20%';
          
          let finalPrice;
          if (isSubscribeSelected) {
            // Apply 20% discount for subscribe
            finalPrice = ap * 0.8;
          } else {
            // Use original price for one-time purchase
            finalPrice = ap;
          }
          
          gp.textContent = `$${(finalPrice / vp).toFixed(2)} / g`;
        }
      });
    }
  }
  
  // Initialize on page load
  initializePricePerGram();
  
  // Re-initialize after a short delay to ensure all elements are loaded
  setTimeout(initializePricePerGram, 500);
  
  typeof showBadge === "function" && showBadge();
});

